export const API_BASE_URL = 'https://offer.app20.in';
export const BASE_URL = 'https://backend.app20.in';
export const WEBSITE_URL = 'https://app20.in';
export const FORMSPREE_URL = 'https://formspree.io/f/mojqqnjb';